import { utcToJSDate } from "@/utils/date-time";
import { PaginationFilterRequest } from "./core.model";
import { City } from "./city.model";

export function runEventDistanceFromJson (json: any): RunEventDistance {
  return {
    ...json,
    startDate: utcToJSDate(json.startDate)!
  } as RunEventDistance;
};

export interface RunEventDistance {
    id: number;
    runEventId: number;
    startLat: number;
    startLon: number;
    endLat: number;
    endLon: number;
    startDate: Date;
    distance: number;
    medalImg?: string;
    city?: City
    hasAchievement: boolean;
    jsonRoute?: string;
    type: RunEventDistanceTypeEnum;  
}

export interface UpsertRunEventDistance {
    id?: number;
    runEventId?: number;
    startLat?: number;
    endLat?: number;
    startLon?: number;
    endLon?: number;
    startDate?: Date;
    distance?: number;
    medalImg?: string;
    jsonRoute?: string;
    type?: RunEventDistanceTypeEnum;  
}

export class RunEventDistancePaginationFilterRequest extends PaginationFilterRequest{  
    runEventId?: number;
}

export enum RunEventDistanceTypeEnum {
    Other = 0,
    Full = 1,
    Half = 2,
    TenKm = 3,
}
export const RunEventDistanceTypeList = [
    {value: 0, label: "Other"},
    {value: 1, label: "Full"},
    {value: 2, label: "Half"},
    {value: 3, label: "Ten Km"},
];